import { createGtag } from 'vue-gtag'
import router from '../router'
import config from '../configs'

const { gaId } = config.analytics

// No-op unless VUE_APP_GA_ID is configured. The previous version of this
// file used the Vue 2 plugin API and was never imported after the Vue 3
// migration, so analytics were silently disabled - this restores them.
export default function installGtag(app) {
  if (!gaId) return

  app.use(createGtag({
    tagId: gaId,
    pageTracker: { router }
  }))
}
